import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { YoutubePlayerModule } from '../video-list-block/video-player/youtube-player.module';
import { ContentComponent } from '@domgen/dgx-fe-components/content';

@Component({
  selector: 'dgx-components-video-list-block',
  templateUrl: './video-block.component.html',
  styleUrls: ['./video-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    CommonModule,
    YoutubePlayerModule,
  ],
  standalone: true,
})
export class SmartFixCustomVideoBlockComponent {
  @Input() autoPlay?: boolean;
  @Input() body?: string;
  @Input() hideControlPanel?: boolean;
  @Input() hideFullScreen?: boolean;
  @Input() title?: string;
  @Input() videoId = '';

  constructor() {}
}
